export default __webpack_public_path__ + "static/media/project1-DJI_0699.b499199b.jpg";